/**
 * Component to display label and value of output page manage header
 * Attributes:
 * @attribute label | String    Label Name
 * @attribute value | String   Value of Output
 * @author Pholla Doll
 * @createdDate 2019-09-03
 * @company REDFOX Web Solutions
 */
 import { Component, Input, OnInit } from '@angular/core';

 @Component({
   selector: 'rds:outputField',
   templateUrl: './output-field.component.html',
   styleUrls: ['./output-field.component.scss']
 })
 export class OutputFieldComponent implements OnInit {
 
   @Input() label: string;
   @Input() value: string;
   @Input() type: string = "text";
   @Input() linkValue: string = "";
   @Input() isCap: boolean = false;
   @Input() toolTipText: string = "View object detail";
   @Input() borders: string ="";
   @Input() isLoading:boolean = false;
   
   constructor() { }
 
   ngOnInit() {
   }
 
 }
 